export const limitString = (text: string) => {
  let limitedString = text?.slice(0, 20);

  return limitedString + "...";
};
